import React, { useState, useContext, useEffect } from "react";
import { NotificationContext } from "./Notification";
import EmailInput from "./EmailInput";
import LoaderPR from "./LoaderPR";
import { redirectPage } from "./Utils";
import { getQueryParams, handleSessionValidation } from "./Theme";
import SSOService from "./SSOService";
import { Form, HeaderForm, DescriptionForm, ContentForm, FooterForm } from "./Form";

function ForgotPassword() {
  const [user, setUser] = useState("");
  const [showLoading, setLoading] = useState(true);
  const { addToast } = useContext(NotificationContext);
  const queryParams = getQueryParams();
  const service = new SSOService();
  useEffect(() => {
    setLoading(true);
    handleSessionValidation(addToast).then(() => {
      setLoading(false);
    });
  }, [addToast]);
  return (
    <Form name="forgotPassword" autoComplete="on">
      <HeaderForm />
      <ContentForm>
        <DescriptionForm
          title="Forgot your Password?"
          description="Please enter your username (email) below, once completed, you will
          receive an email with a confirmation code. This code will be use in the
          following step to reset your password."
        />
        <EmailInput name="email" onChange={setUser} />
        <LoaderPR showLoading={showLoading} />
      </ContentForm>
      <FooterForm>
        <button
          disabled={showLoading}
          className="zds-button-primary zds-button-large"
          type="submit"
          onClick={(event) => {
            event.preventDefault();
            if (user.trim() === "") {
              addToast("Email is required.", "error");
              return;
            }
            setLoading(true);
            handleSessionValidation(addToast).then(() => {
              service
                .forgotPassword(user)
                .then(() => {
                  redirectPage(`/passwordrecovery/${user}${queryParams}`);
                })
                .catch((err) => {
                  setLoading(false);
                  addToast(err.error, "error");
                });
            });
          }}
        >
          Continue
        </button>
      </FooterForm>
    </Form>
  );
}

export default ForgotPassword;
